// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","left":"Header_left__Wc76D","right":"Header_right__aQqPZ","title":"Header_title__rzFD1","backBtn":"Header_backBtn__6Mofc"};